
export const getDefaultChannelCover = (type: string) => {
    switch(type) {
        case 'BachelorsDegree':
            return '#5A5CAA'
        case 'MastersDegree':
            return '#C15B4F'
        default:
            return '#909090'
    }
}
export const getDefaultChannelCover = (type: string) => {
    switch(type) {
        case 'BachelorsDegree':
            return '#5A5CAA'
        case 'MastersDegree':
            return '#C15B4F'
        default:
            return '#909090'
    }
}